import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from './translations';
import { safeLocalStorage } from '../utils/safeStorage';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = safeLocalStorage.getItem('appLanguage');
    return savedLanguage || 'fr';
  });

  useEffect(() => {
    safeLocalStorage.setItem('appLanguage', language);
  }, [language]);

  const t = (key, params = {}) => {
    const keys = key?.split('.');
    let value = translations?.[language];
    
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) {
        return key;
      }
    }
    
    if (typeof value === 'string' && params) {
      return value?.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
        return params?.[paramKey] !== undefined ? params?.[paramKey] : match;
      });
    }
    
    return value || key;
  };

  const changeLanguage = (newLanguage) => {
    if (translations?.[newLanguage]) {
      setLanguage(newLanguage);
    }
  };

  let value = {
    language,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;